// Client for the Investor Outreach endpoints (S2/S3, gateway route /investor-outreach/**).
// Each call resolves to { ok, data } or { ok: false, status, errorCode, message } and never throws.
// userId must be the signed-in user, otherwise the backend answers 403 IO_USER_MISMATCH.
import config from 'config';

const {
  constants: {
    API: { PRICING_UPDATE_URL },
  },
} = config;

const BASE = `${PRICING_UPDATE_URL}/investor-outreach`;

const request = async (method, path, body) => {
  try {
    const response = await fetch(`${BASE}${path}`, {
      method,
      headers: {
        'Content-Type': 'application/json',
        'x-auth-token': window.appAuthToken,
      },
      body: body ? JSON.stringify(body) : undefined,
    });
    const text = await response.text();
    let data = null;
    try {
      data = text ? JSON.parse(text) : null;
    } catch (e) {
      data = null;
    }
    if (response.ok) {
      return { ok: true, data };
    }
    return {
      ok: false,
      status: response.status,
      errorCode: data?.errorCode,
      message: data?.message,
      data,
    };
  } catch (error) {
    return { ok: false, errorCode: 'NETWORK_ERROR', message: error?.message };
  }
};

// S3: price preview (read-only).
export const getPricingPreview = (userId) => request('GET', `/pricing-preview/user/${userId}`);

// S2: cancel preview (read-only). 409 IO_NOT_SUBSCRIBED if there is no live subscription.
export const getCancelPreview = (userId) => request('GET', `/cancel-preview/user/${userId}`);

// S2: subscribe. Charges the card for the previewed dueToday.
export const subscribe = (payload) => request('POST', '/subscribe', payload);

// S2: undo a pending cancellation.
export const restore = (payload) => request('POST', '/restore', payload);

// S2: unsubscribe. Ends at the end of the paid period.
export const unsubscribe = (payload) => request('DELETE', '/unsubscribe', payload);
